import { validate } from './validate';

const STUDIO_NAME_ACCOUNT_TYPES = ['studio', 'artistInStudio'];

function syncStudioNameVisibility(form) {
  if (!form) return;

  const accountType = form.querySelector('[name="fields[accountType]"]');
  const studioField = form.querySelector('[data-studio-name-field]');
  if (!accountType || !studioField) return;

  const studioInput = studioField.querySelector('[name="fields[studioName]"]');

  const sync = () => {
    const show = STUDIO_NAME_ACCOUNT_TYPES.includes(accountType.value);
    studioField.hidden = !show;
    if (!show && studioInput) {
      studioInput.value = '';
    }
  };

  accountType.addEventListener('change', sync);
  sync();
}

document.addEventListener('DOMContentLoaded', () => {
  validate(document.getElementById('form_login'), {
    rules: {
      loginName: ['required', 'email'],
      password: ['required'],
    },
  });

  const formProfile = document.getElementById('form_profile');
  validate(formProfile, {
    rules: {
      firstName: ['required'],
      lastName: ['required'],
      'fields[phone]': ['required', 'phoneNumber'],
      'fields[accountType]': ['required'],
      'fields[studioName]': [
        ['requiredIf', 'fields[accountType]', 'studio'],
        ['requiredIf', 'fields[accountType]', 'artistInStudio'],
        'maxLength:50',
      ],
    },
  });
  syncStudioNameVisibility(formProfile);

  validate(document.getElementById('form_activation'), {
    rules: {
      loginName: ['required', 'email'],
    },
  });

  validate(document.getElementById('form_forgot'), {
    rules: {
      loginName: ['required', 'email'],
    },
  });

  validate(document.getElementById('form_set'), {
    rules: {
      newPassword: ['required', 'minLength:10'],
      newPasswordConfirmation: ['required', 'passwordConfirmation:newPassword'],
      passwordStrength: ['passwordStrength'],
    },
  });

  validate(document.getElementById('form_pass'), {
    rules: {
      newPassword: ['required', 'minLength:10'],
      newPasswordConfirmation: ['required', 'passwordConfirmation:newPassword'],
      passwordStrength: ['passwordStrength'],
      password: ['required'],
    },
  });

  validate(document.getElementById('form_email'), {
    rules: {
      email: ['required', 'email'],
      password: ['required'],
    },
  });

  const formRegister = document.getElementById('form_register');
  validate(formRegister, {
    rules: {
      firstName: ['required'],
      lastName: ['required'],
      email: ['required', 'email'],
      'fields[phone]': ['required', 'phoneNumber'],
      'fields[accountType]': ['required'],
      'fields[studioName]': [
        ['requiredIf', 'fields[accountType]', 'studio'],
        ['requiredIf', 'fields[accountType]', 'artistInStudio'],
        'maxLength:50',
      ],
      password: ['required', 'minLength:10'],
      passwordConfirmation: ['required', 'passwordConfirmation:password'],
      passwordStrength: ['passwordStrength'],
    },
  });
  syncStudioNameVisibility(formRegister);
});
